/* Figma frame 2161:4787 — 1440 wide.
   Sidebar 212 | TopBar 50 | FilterChips 57 | content starts x=265 y=130. */
.shell { display: flex; min-height: 100vh; background: var(--bg-page); }

.main { display: flex; flex-direction: column; flex: 1 0 0; min-width: 0; }

.content {
  display: flex;
  flex-direction: column;
  gap: var(--table-gap);
  /* content x=265 − sidebar 212 = 53; y=130 − (50 + 57) = 23 */
  padding: 23px 0 48px 53px;
}

/* A refetch dims the tables instead of unmounting them: drilling into a
   category must never blank 21 rows of sparklines and reflow the page. */
.content[data-fetching='true'] > section {
  opacity: 0.55;
  transition: opacity 120ms ease-out;
}

/* Granted brand, no data. Stated plainly so an empty dashboard is not mistaken
   for a broken one. */
.emptyBrand {
  margin: 0 0 4px;
  padding: 12px 14px;
  border: 1px solid #e6e2c9;
  border-left: 3px solid #d8b23f;
  border-radius: 8px;
  background: #fffdf4;
  color: #5d5326;
  font-size: 13px;
  line-height: 18px;
}
